module.exports = __webpack_public_path__ + "static/media/3.cabb0574.jpg";